export class ColorUtils {
  public static getCssVariableValue = (themeColor: string): string => {
    const cssVariableName = themeColor.replace('var(', '').replace(')', '');
    const hexColorValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariableName).trim();
    return hexColorValue;
  };
}
